module.exports = __webpack_public_path__ + "img/shopbase-four-en.a29af9bd.png";